import { render, staticRenderFns } from "./TheGraphics.vue?vue&type=template&id=38a12402&scoped=true"
import script from "./TheGraphics.vue?vue&type=script&lang=js"
export * from "./TheGraphics.vue?vue&type=script&lang=js"
import style0 from "./TheGraphics.vue?vue&type=style&index=0&id=38a12402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a12402",
  null
  
)

export default component.exports